/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DataBehindTheVisAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class DataBehindTheVisAPI {

		/**
		* @public
		* @function DataBehindTheVisAPI#getData
		* @description Get the data behind the vis
		* @param {Boolean} doAggregate boolean value to indicate whether export data is aggregated or disaggregated, Default = true
		* @return {Object} dataBehindTheVis data object
		*/
		getData(/*doAggregate*/) {}

		/**
		* @public
		* @function DataBehindTheVisAPI#export
		* @description Exports the vis data to CSV format
		* @param {Boolean} doAggregate boolean value to indicate whether export data is aggregated or disaggregated, Default = true
		* @return {Object} dataBehindTheVis data object
		* @example
		*/
		export(/*doAggregate*/) {}

	}

	return DataBehindTheVisAPI;
});
